// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Table Container */
.table-container {
  background: var(--assistant-message-background);
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px;
  margin: 10px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
}

[data-theme='dark'] .table-container {
  background: var(--assistant-message-background);
  border-color: #555;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Table Header */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
}

[data-theme='dark'] .table-header {
  border-bottom-color: #555;
}

.table-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-color);
}

.table-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* When title is hidden, center the controls */
.table-header.no-title .table-controls {
  margin: 0 auto;
}

.format-selector {
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: var(--background-color);
  color: var(--text-color);
  font-size: 14px;
  cursor: pointer;
}

[data-theme='dark'] .format-selector {
  border-color: #666;
  background: var(--input-background-color);
}

.download-btn,
.fullscreen-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  background: #007bff;
  color: white;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: background-color 0.2s;
}

.download-btn:hover,
.fullscreen-btn:hover {
  background: #0056b3;
}

[data-theme='dark'] .download-btn,
[data-theme='dark'] .fullscreen-btn {
  background: #4a90e2;
}

[data-theme='dark'] .download-btn:hover,
[data-theme='dark'] .fullscreen-btn:hover {
  background: #357abd;
}

/* Table Wrapper */
.table-wrapper {
  overflow-x: hidden;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  max-width: 100%;
  position: relative;
  box-sizing: border-box;
}

[data-theme='dark'] .table-wrapper {
  border-color: #555;
}

/* Data Table */
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
  box-sizing: border-box;
}

/* Ensure table cells handle long text properly */
.table-cell {
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  vertical-align: top;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  line-height: 1.4;
  box-sizing: border-box;
  overflow: hidden;
}

[data-theme='dark'] .table-cell {
  border-bottom-color: #555;
}

.table-header-cell {
  background: #f8f9fa;
  color: #495057;
  font-weight: 600;
  padding: 12px 16px;
  text-align: left;
  border-bottom: 2px solid #dee2e6;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  vertical-align: top;
  line-height: 1.4;
  white-space: normal;
  box-sizing: border-box;
  overflow: hidden;
}

[data-theme='dark'] .table-header-cell {
  background: #2d3748;
  color: #e2e8f0;
  border-bottom-color: #4a5568;
}

.table-row {
  transition: background-color 0.2s;
}

.table-row:nth-child(even) {
  background: #f8f9fa;
}

[data-theme='dark'] .table-row:nth-child(even) {
  background: #2d3748;
}

.table-row:hover {
  background: #e9ecef;
}

[data-theme='dark'] .table-row:hover {
  background: #4a5568;
}

.table-cell {
  padding: 12px 16px;
  border-bottom: 1px solid #dee2e6;
  color: var(--text-color);
  vertical-align: top;
  word-wrap: break-word;
  max-width: 200px;
}

[data-theme='dark'] .table-cell {
  border-bottom-color: #4a5568;
}

/* Fullscreen Modal */
.fullscreen-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.fullscreen-content {
  background: var(--background-color);
  border-radius: 12px;
  width: 100%;
  height: 100%;
  max-width: 95vw;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

[data-theme='dark'] .fullscreen-content {
  background: var(--background-color);
}

.fullscreen-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  background: var(--header-background-color);
}

[data-theme='dark'] .fullscreen-header {
  border-bottom-color: #555;
}

.fullscreen-title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: var(--text-color);
}

.close-fullscreen-btn {
  padding: 10px;
  border: none;
  border-radius: 50%;
  background: #dc3545;
  color: white;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.close-fullscreen-btn:hover {
  background: #c82333;
}

.fullscreen-table-container {
  flex: 1 1;
  overflow: auto;
  padding: 20px;
}

.fullscreen-table-container .table-container {
  margin: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.fullscreen-table-container .table-wrapper {
  flex: 1 1;
  overflow: auto;
}

.fullscreen-table-container .data-table {
  min-width: 100%;
}

/* Error State */
.table-error {
  padding: 20px;
  text-align: center;
  color: #dc3545;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 8px;
  margin: 10px 0;
}

[data-theme='dark'] .table-error {
  background: #721c24;
  border-color: #f5c6cb;
  color: #f8d7da;
}

/* Responsive Design */
@media (max-width: 768px) {
  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .table-controls {
    width: 100%;
    justify-content: space-between;
  }
  
  .table-title {
    font-size: 16px;
  }
  
  .data-table {
    font-size: 12px;
    min-width: 500px;
  }
  
  .table-cell,
  .table-header-cell {
    padding: 8px 12px;
  }
  
  .fullscreen-content {
    max-width: 100vw;
    max-height: 100vh;
    border-radius: 0;
  }
  
  .fullscreen-header {
    padding: 15px;
  }
  
  .fullscreen-title {
    font-size: 20px;
  }
  
  .fullscreen-table-container {
    padding: 15px;
  }
}

/* Animation for fullscreen toggle */
.fullscreen-modal {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Scrollbar styling for table wrapper */
.table-wrapper::-webkit-scrollbar {
  height: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

[data-theme='dark'] .table-wrapper::-webkit-scrollbar-track {
  background: #2d3748;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

[data-theme='dark'] .table-wrapper::-webkit-scrollbar-thumb {
  background: #4a5568;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

[data-theme='dark'] .table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #718096;
}
`, "",{"version":3,"sources":["webpack://./src/components/TableRenderer.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,8CAA8C;AAC9C;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,wBAAwB;EACxB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,wCAAwC;AACxC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Table Container */\n.table-container {\n  background: var(--assistant-message-background);\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  padding: 16px;\n  margin: 10px 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  max-width: 100%;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n[data-theme='dark'] .table-container {\n  background: var(--assistant-message-background);\n  border-color: #555;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n/* Table Header */\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n[data-theme='dark'] .table-header {\n  border-bottom-color: #555;\n}\n\n.table-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-color);\n}\n\n.table-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* When title is hidden, center the controls */\n.table-header.no-title .table-controls {\n  margin: 0 auto;\n}\n\n.format-selector {\n  padding: 6px 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  background: var(--background-color);\n  color: var(--text-color);\n  font-size: 14px;\n  cursor: pointer;\n}\n\n[data-theme='dark'] .format-selector {\n  border-color: #666;\n  background: var(--input-background-color);\n}\n\n.download-btn,\n.fullscreen-btn {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 6px;\n  background: #007bff;\n  color: white;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  transition: background-color 0.2s;\n}\n\n.download-btn:hover,\n.fullscreen-btn:hover {\n  background: #0056b3;\n}\n\n[data-theme='dark'] .download-btn,\n[data-theme='dark'] .fullscreen-btn {\n  background: #4a90e2;\n}\n\n[data-theme='dark'] .download-btn:hover,\n[data-theme='dark'] .fullscreen-btn:hover {\n  background: #357abd;\n}\n\n/* Table Wrapper */\n.table-wrapper {\n  overflow-x: hidden;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  max-width: 100%;\n  position: relative;\n  box-sizing: border-box;\n}\n\n[data-theme='dark'] .table-wrapper {\n  border-color: #555;\n}\n\n/* Data Table */\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  table-layout: fixed;\n  box-sizing: border-box;\n}\n\n/* Ensure table cells handle long text properly */\n.table-cell {\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n  vertical-align: top;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  line-height: 1.4;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n[data-theme='dark'] .table-cell {\n  border-bottom-color: #555;\n}\n\n.table-header-cell {\n  background: #f8f9fa;\n  color: #495057;\n  font-weight: 600;\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 2px solid #dee2e6;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  vertical-align: top;\n  line-height: 1.4;\n  white-space: normal;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n[data-theme='dark'] .table-header-cell {\n  background: #2d3748;\n  color: #e2e8f0;\n  border-bottom-color: #4a5568;\n}\n\n.table-row {\n  transition: background-color 0.2s;\n}\n\n.table-row:nth-child(even) {\n  background: #f8f9fa;\n}\n\n[data-theme='dark'] .table-row:nth-child(even) {\n  background: #2d3748;\n}\n\n.table-row:hover {\n  background: #e9ecef;\n}\n\n[data-theme='dark'] .table-row:hover {\n  background: #4a5568;\n}\n\n.table-cell {\n  padding: 12px 16px;\n  border-bottom: 1px solid #dee2e6;\n  color: var(--text-color);\n  vertical-align: top;\n  word-wrap: break-word;\n  max-width: 200px;\n}\n\n[data-theme='dark'] .table-cell {\n  border-bottom-color: #4a5568;\n}\n\n/* Fullscreen Modal */\n.fullscreen-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.fullscreen-content {\n  background: var(--background-color);\n  border-radius: 12px;\n  width: 100%;\n  height: 100%;\n  max-width: 95vw;\n  max-height: 95vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n[data-theme='dark'] .fullscreen-content {\n  background: var(--background-color);\n}\n\n.fullscreen-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background: var(--header-background-color);\n}\n\n[data-theme='dark'] .fullscreen-header {\n  border-bottom-color: #555;\n}\n\n.fullscreen-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--text-color);\n}\n\n.close-fullscreen-btn {\n  padding: 10px;\n  border: none;\n  border-radius: 50%;\n  background: #dc3545;\n  color: white;\n  cursor: pointer;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.close-fullscreen-btn:hover {\n  background: #c82333;\n}\n\n.fullscreen-table-container {\n  flex: 1;\n  overflow: auto;\n  padding: 20px;\n}\n\n.fullscreen-table-container .table-container {\n  margin: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.fullscreen-table-container .table-wrapper {\n  flex: 1;\n  overflow: auto;\n}\n\n.fullscreen-table-container .data-table {\n  min-width: 100%;\n}\n\n/* Error State */\n.table-error {\n  padding: 20px;\n  text-align: center;\n  color: #dc3545;\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  border-radius: 8px;\n  margin: 10px 0;\n}\n\n[data-theme='dark'] .table-error {\n  background: #721c24;\n  border-color: #f5c6cb;\n  color: #f8d7da;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .table-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .table-controls {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .table-title {\n    font-size: 16px;\n  }\n  \n  .data-table {\n    font-size: 12px;\n    min-width: 500px;\n  }\n  \n  .table-cell,\n  .table-header-cell {\n    padding: 8px 12px;\n  }\n  \n  .fullscreen-content {\n    max-width: 100vw;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n  \n  .fullscreen-header {\n    padding: 15px;\n  }\n  \n  .fullscreen-title {\n    font-size: 20px;\n  }\n  \n  .fullscreen-table-container {\n    padding: 15px;\n  }\n}\n\n/* Animation for fullscreen toggle */\n.fullscreen-modal {\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Scrollbar styling for table wrapper */\n.table-wrapper::-webkit-scrollbar {\n  height: 8px;\n}\n\n.table-wrapper::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n[data-theme='dark'] .table-wrapper::-webkit-scrollbar-track {\n  background: #2d3748;\n}\n\n.table-wrapper::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n[data-theme='dark'] .table-wrapper::-webkit-scrollbar-thumb {\n  background: #4a5568;\n}\n\n.table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n[data-theme='dark'] .table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #718096;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
